'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'diploma';
var width = 640;
var height = 512;
var aliases = ["scroll-ribbon"];
var unicode = 'f5ea';
var svgPathData = 'M539.3 144h-66.1C477.5 134.2 480 123.4 480 112C480 68.15 444.3 32 400.5 32C367.7 32 345.5 47.09 320 78.95C294.5 47.09 272.3 32 239.5 32C195.7 32 160 68.15 160 112c0 11.4 2.506 22.19 6.844 32H96c-53.02 0-96 48.47-96 128S42.98 416 96 416l160-34.29v82.26c0 2.98 .9551 5.52 2.266 7.805c.3672 .6445 .7793 1.156 1.227 1.734c1.244 1.613 2.709 2.926 4.438 3.953c.5078 .3008 .9023 .6758 1.438 .9219C267.5 479.4 269.7 480 272.1 480c.2383 0 .4766-.1016 .7148-.1172c.3438-.0156 .6523-.1172 .9961-.1562c2.688-.2969 5.381-1.121 7.826-2.957L320 447.1l38.4 28.78c2.445 1.836 5.139 2.66 7.826 2.957c.3438 .0391 .6523 .1406 .9961 .1562C367.5 479.9 367.7 480 367.9 480c2.35 0 4.592-.6406 6.693-1.613c.5371-.2461 .9355-.6211 1.443-.9258c1.73-1.031 3.195-2.336 4.439-3.953c.4453-.5781 .8535-1.086 1.219-1.727C383 469.5 384 466.1 384 463.1v-81.96L539.3 416C594.9 416 640 351.5 640 272C640 192.5 594.9 144 539.3 144zM400.5 80.47C417.9 80.47 432 94.59 432 112s-14.11 31.53-31.53 31.53H332.6C373.2 83.07 384.8 80.47 400.5 80.47zM239.5 80.47c15.69 0 27.27 2.6 67.86 63.06H239.5C222.1 143.5 208 129.4 208 112S222.1 80.47 239.5 80.47zM245.9 334.8l-153.4 32.86C73.29 363.7 48 327.3 48 272C48 224.9 67.74 192 96 192h144.6L240.3 191.5H256v141.1L245.9 334.8zM543 367.7L384 332.9V191.5h15.65L399.4 192h139.8C570.8 192 592 224.1 592 272C592 324.2 566.9 363.8 543 367.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiploma = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;